export default __webpack_public_path__ + "static/img-media-cointelegraph-b067c249de5a0a7a1e817ca37c16e84d.jpeg";